import {REGISTERED_DURATION_CONTRACT_ENTRIES} from './marks';
import type {
  PerformanceDurationContract,
  PerformanceDurationMarkContract,
} from './types';

/**
 * Static perf duration mark allowlist.
 * Keeps unknown marks from becoming telemetry.
 */
export const REGISTERED_DURATION_CONTRACTS_BY_NAME = new Map<
  string,
  PerformanceDurationMarkContract
>(REGISTERED_DURATION_CONTRACT_ENTRIES);

/**
 * Lets unknown marks pass through without becoming RUM durations
 */
export function getDurationContractForMark(
  markName: string,
  phase: PerformanceDurationMarkContract['phase']
): PerformanceDurationContract | null {
  const indexedContract = REGISTERED_DURATION_CONTRACTS_BY_NAME.get(markName);
  if (indexedContract == null || indexedContract.phase !== phase) {
    return null;
  }

  return indexedContract.contract;
}
